module.exports = __webpack_public_path__ + "static/img/app1.f68a963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app1.jpg
// module id = FIrF
// module chunks = 1